import React from "react";
import { FeedHeaderWithLogoProps } from "web/react/components/feed-header-with-logo/feed-header-with-logo";
import { Heading } from "web/react/emo/heading";
import { Text } from "web/react/emo/text";
import { VStack } from "web/react/emo/v-stack";

export function FeedHeaderTitle({
    type,
    title,
    subtitle,
}: Pick<FeedHeaderWithLogoProps, "type" | "title" | "subtitle">): JSX.Element {
    const subtitleElement = subtitle && (
        <Text as={"span"} textStyle={"caption-1"}>
            {subtitle}
        </Text>
    );

    if (type === "RELATED_PRODUCTS") {
        return (
            <VStack spacing="xxs">
                {subtitleElement}
                <Heading textStyle={{ sm: "title-2", lg: "title-1" }} linkReset={false}>
                    {title}
                </Heading>
            </VStack>
        );
    }

    return (
        <VStack spacing="xxs">
            <Heading textStyle={{ sm: "title-2", lg: "large-title" }}>{title}</Heading>
            {subtitleElement}
        </VStack>
    );
}
